import { AnimationDefinition, UnlockableAnimation } from "../types/unlock";

export const ANIMATIONS: Record<UnlockableAnimation, AnimationDefinition> = {
  Backflip: {
    id: "Backflip",
    avatarAnimation: "Backflip",
    name: "Backflip",
    baseCooldown: 8,
    durationMs: 1600,
    soundEffect: {
      src: "/audio/backflip.mp3",
      duckVolume: 0.05,
      durationMs: 3600,
    },
    effects: [
      {
        type: "add_real_viewers",
        amount: 25,
      },
    ],
  },

  Pose_confident: {
    id: "Pose_confident",
    avatarAnimation: "Pose_confident",
    name: "Confident Pose",
    baseCooldown: 6,
    durationMs: 2600,
    effects: [
      {
        type: "likes_per_second_multiplier",
        multiplier: 1.5,
        duration: 5,
      },
    ],
  },

  AuraFarmer: {
    id: "AuraFarmer",
    avatarAnimation: "AuraFarmer",
    name: "Aura Farmer",
    baseCooldown: 12,
    durationMs: 8500,
    soundEffect: {
      src: "/audio/aura-farming.mp3",
      duckVolume: 0.14,
      durationMs: 8500,
    },
    effects: [
      {
        type: "add_real_viewers",
        amount: 12,
      },
      {
        type: "likes_per_second_multiplier",
        multiplier: 1.35,
        duration: 8,
      },
    ],
  },

  Dance: {
    id: "Dance",
    avatarAnimation: "Dance",
    name: "Dance",
    baseCooldown: 10,
    durationMs: 6200,
    effects: [
      {
        type: "add_real_viewers",
        amount: 15,
      },
      {
        type: "gift_rate_multiplier",
        multiplier: 1.75,
        duration: 6,
      },
    ],
  },
};
